import dayjs from 'dayjs';
import { CalendarDimensions } from '@enums';

/**
 * This fn returns time difference in seconds igonring time shift (summer vs winter time).
 */
export const getTimeDiffIgnoringTimeShift = (
  fromUnix: number,
  toUnix: number,
  dimension: CalendarDimensions = CalendarDimensions.DAY
): number => {
  const from = dayjs.unix(fromUnix);
  const to = dayjs.unix(toUnix);

  if (dimension === CalendarDimensions.DAY) {
    const f = dayjs(`2025-01-01T${from.hour()}:${from.minute()}`);
    const t = dayjs(`2025-01-01T${to.hour()}:${to.minute()}`);
    return t.diff(f, 'second');
  }

  const days = to.diff(from, 'day');
  const f = dayjs(`2025-01-01T${from.hour()}:${from.minute()}`);
  const t = dayjs(`2025-01-${getDaysString(days)}T${to.hour()}:${to.minute()}`);

  return t.diff(f, 'second');
};

const getDaysString = (days: number): string =>
  days >= 9 ? `${days + 1}` : `0${days + 1}`;
